import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UserModel } from '../models/user.model';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  override dbName = 'User';
  override collection = '/user';

  constructor(http: HttpClient) {
    super(http, 'User', '/user', UserModel);
  }

  getProfile<T>(options = {}): Observable<T> {
    return this.http.get<T>(`${this.uri}/me`, { headers: this.defaultHeaders, ...options }).pipe(
      map((response: any) => {
        const data =
          response?.data ?
            this.Model ?
              new this.Model(response.data)
            : null
          : null;
        return { ...response, data };
      })
    );
  }

  updateProfile<T>(body: any, options = {}): Observable<T> {
    return this.http.put<T>(`${this.uri}/me`, body, {
      ...options,
    });
  }

  changePassword<T>(body: any, options = {}): Observable<T> {
    return this.http.put<T>(`${this.uri}/me/credential`, body, {
      ...options,
    });
  }

  updateLanguage<T>(language: 'en' | 'pt', options = {}): Observable<T> {
    return this.http.put<T>(`${this.uri}/me/language`, { language }, { ...options });
  }
}
